// store/modules/filters/tinderAccountsFilter.js

const state = {
    filterBlock: {},
    countTinderAccounts: 50,
    chosenPage: 1,
};

const mutations = {
    setFilterBlock(state, filterBlock) {
        state.filterBlock = filterBlock;
    },
    setCountTinderAccounts(state, countTinderAccounts) {
        state.countTinderAccounts = countTinderAccounts;
    },
    setChosenPage(state, chosenPage) {
        state.chosenPage = chosenPage;
    },

};

const actions = {
    updateFilterBlock({ commit }, filterBlock) {
        commit('setFilterBlock', filterBlock);
    },
    updateCountTinderAccounts({ commit }, countTinderAccounts) {
        commit('setCountTinderAccounts', countTinderAccounts);
    },
    updateChosenPage({ commit }, chosenPage) {
        commit('setChosenPage', chosenPage);
    },
};

const getters = {
    getFilterBlock: (state) => state.filterBlock,
    getCountTinderAccounts: (state) => state.countTinderAccounts,
    getChosenPage: (state) => state.chosenPage,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};